const Input = ({ label, value, onChange, suffix, type = 'text', step }) => (
    <div className="form-group">
        <label>{label}</label>

        <div className="input-suffix">
            <input type={type} value={value} step={step} onChange={onChange} />
            {suffix && <span className="suffix">{suffix}</span>}
        </div>
    </div>
);

export default Input;
